<template>
  <section id="how-it-works" class="home3-steps">
    <v-container>
      <div class="home3-section-header text-center mb-10">
        <span class="home3-section-header__tag">How It Works</span>
        <h2 class="home3-section-header__title">Get started in three simple steps</h2>
        <p class="home3-section-header__desc">
          From registration to live tracking — up and running in minutes.
        </p>
      </div>

      <v-row justify="center">
        <v-col
          v-for="(step, i) in steps"
          :key="i"
          cols="12"
          md="4"
        >
          <div class="home3-step">
            <div class="home3-step__number">{{ i + 1 }}</div>
            <div class="home3-step__icon-wrap">
              <v-icon color="primary" size="32">{{ step.icon }}</v-icon>
            </div>
            <h3 class="home3-step__title">{{ step.title }}</h3>
            <p class="home3-step__text">{{ step.text }}</p>
            <div v-if="i < steps.length - 1" class="home3-step__connector d-none d-md-block" />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="home3-steps__wave">
      <img src="@/assets/images/landing/wave2.svg" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      steps: [
        {
          icon: 'mdi-school-outline',
          title: 'Register your school',
          text: 'Sign up, configure your school profile, and set up your subscription plan to get started.',
        },
        {
          icon: 'mdi-bus-multiple',
          title: 'Set up your fleet',
          text: 'Add buses, define routes and stops, assign drivers, and schedule trips for your students.',
        },
        {
          icon: 'mdi-radar',
          title: 'Track in real time',
          text: 'Monitor live locations, send parent notifications, and manage every trip from your dashboard.',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import './home3-theme.scss';

.home3-steps {
  @include home3-section-padding;
  position: relative;
  background: $home3-surface-alt;
  padding-bottom: 6rem;

  .container {
    position: relative;
    z-index: 2;
  }
}

.home3-section-header {
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;

  &__tag {
    display: inline-block;
    padding: 4px 14px;
    margin-bottom: 1rem;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: $home3-primary;
    background: rgba($home3-primary, 0.1);
    border-radius: 100px;
  }

  &__title {
    font-size: clamp(1.75rem, 3vw, 2.25rem);
    font-weight: 700;
    color: $home3-text;
    letter-spacing: -0.02em;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  &__desc {
    font-size: 1.05rem;
    line-height: 1.7;
    color: $home3-text-muted;
    margin: 0;
  }
}

.home3-step {
  position: relative;
  text-align: center;
  padding: 2rem 1.5rem;

  &__number {
    position: absolute;
    top: 0;
    right: 1.5rem;
    font-size: 3.5rem;
    font-weight: 800;
    color: rgba($home3-navy, 0.06);
    line-height: 1;
    user-select: none;
  }

  &__icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    margin-bottom: 1.25rem;
    background: #fff;
    border-radius: 50%;
    box-shadow: $home3-shadow;
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 600;
    color: $home3-text;
    margin-bottom: 0.75rem;
  }

  &__text {
    font-size: 0.925rem;
    line-height: 1.65;
    color: $home3-text-muted;
    margin: 0;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  &__connector {
    position: absolute;
    top: 3.5rem;
    right: -20%;
    width: 40%;
    height: 2px;
    background: linear-gradient(90deg, rgba($home3-primary, 0.4), rgba($home3-primary, 0.1));
  }
}

.home3-steps__wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  line-height: 0;
  z-index: 0;
  pointer-events: none;

  img {
    width: 100%;
    display: block;
  }
}
</style>
